export default __webpack_public_path__ + "static/media/app-icon.9538c62a.png";